import React from 'react';
import Login from 'features/shared/Login';

const LoginPage = () => {
	return <Login />;
};

export default LoginPage;
